module.exports = __webpack_public_path__ + "img/biletbanklogo.c6a7ac4e.png";